import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useAvanceMetaTotalGauge from "../../../hooks/administrador/general/useAvanceMetaTotalGauge";
import '../../../styles/administrador.css';

const AvanceMetaTotalGauge = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const data = useAvanceMetaTotalGauge(year, mes, token, idAdministrador);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

       
      const esAcumulado = data.length > 1;
      
       
      let reencaucheTotal, cantidadRecolectadaTotal, metaEstablecidaTotal, metaTotal;
       
      let nombreMes = '';
      
      if (!esAcumulado) {
         
        const item = data[0];
        nombreMes = item.mes || '';
        
         
        reencaucheTotal = parseFloat(item.Reencauche || 0);
        cantidadRecolectadaTotal = parseFloat(item.cantidad_recolectada || 0);
        metaEstablecidaTotal = parseFloat(item.meta_establecida || 0);
        
         
        const metaOperativa = parseFloat(item.meta_operativa || 0);
        const metaEstablecida = parseFloat(item.meta_establecida || 0);
        const metaProyectada = parseFloat(item.meta_proyectada || 0);
        metaTotal = metaOperativa + metaEstablecida + metaProyectada;
      } else {
         
        reencaucheTotal = data.reduce((sum, item) => sum + parseFloat(item.Reencauche || 0), 0);
        cantidadRecolectadaTotal = data.reduce((sum, item) => sum + parseFloat(item.cantidad_recolectada || 0), 0);
        metaEstablecidaTotal = data.reduce((sum, item) => sum + parseFloat(item.meta_establecida || 0), 0);
        metaTotal = data.reduce((sum, item) => {
          const metaOperativa = parseFloat(item.meta_operativa || 0);
          const metaEstablecida = parseFloat(item.meta_establecida || 0);
          const metaProyectada = parseFloat(item.meta_proyectada || 0);
          return sum + metaOperativa + metaEstablecida + metaProyectada;
        }, 0);
      }

       
      const totalGestionado = reencaucheTotal + cantidadRecolectadaTotal + metaEstablecidaTotal;

      let porcentajeAvance = (totalGestionado / metaTotal) * 100;
      porcentajeAvance = Math.min(porcentajeAvance, 200).toFixed(1);
      
      const formatValue = (value, isForAxis = true) => {
        if (value >= 1000000) {
          return (value / 1000000).toFixed(3) + 'M';
        }
        if (value >= 1000) {
          if (isForAxis) {
            return (value / 1000).toFixed(0) + 'k';
          } else {
            return value.toLocaleString();
          }
        }
        return value.toLocaleString();
      };

      const formatSubtitleValue = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      };

      const maxValue = totalGestionado > metaTotal ?
        Math.ceil(totalGestionado * 1.2 / 10000) * 10000 :
        metaTotal;

       
      let titulo = '';
      let subtitulo = '';
      
      if (esAcumulado) {
        titulo = 'Avance de meta total de gestión';
        subtitulo = `META TOTAL: ${formatSubtitleValue(metaTotal)} NFU`;
      } else {
         
        titulo = `Avance de meta \nde ${nombreMes.toLowerCase()}`;
        subtitulo = `META MENSUAL: ${formatSubtitleValue(metaTotal)} NFU`;
      }

      const option = {
        title: {
          text: titulo,
          left: 'center',
          subtext: subtitulo,
          textStyle: {
            color: '#333',
            fontSize: 20,
            fontWeight: 'bold'
          },
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: '12px'
          },
          padding: [15, 0, 0, 0]
        },
        tooltip: {
        confine: true,
        formatter: function(params) {
          return `<div style="line-height: 1.2; font-size: 12px;">
            <b>Gestión operativa:</b> ${cantidadRecolectadaTotal.toLocaleString()} NFU<br/>
            <b>Reencauche:</b> ${reencaucheTotal.toLocaleString()} NFU<br/>
            <b>Excedente:</b> ${metaEstablecidaTotal.toLocaleString()} NFU<br/>
            <b>Total gestionado:</b> ${totalGestionado.toLocaleString()} NFU<br/>
            <b>Meta ${esAcumulado ? 'proyectada' : 'mensual'}:</b> ${metaTotal.toLocaleString()} NFU<br/>
            <b>Avance:</b> ${porcentajeAvance}%
          </div>`;
          }
        },
        series: [{
          type: 'gauge',
          radius: '90%',
          center: ['50%', '60%'],
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: maxValue,
          splitNumber: 5,
          progress: {
            show: true,
            roundCap: true,
            width: 25,
            itemStyle: {
              color: '#B5CC18'
            }
          },
          pointer: {
            length: '55%',
            width: 10,
            offsetCenter: [0, '10%'],
            itemStyle: {
              color: '#BBCD21'
            }
          },
          axisLine: {
            roundCap: true,
            lineStyle: {
              width: 25,
              color: [
                [0.7, '#FF6E76'],
                [1.0, '#FDDD60'],
                [1.0, '#4CAF50']
              ]
            }
          },
          axisLabel: {
            distance: 30,
            color: '#333',
            fontSize: 14,
            formatter: function(value) {
              return formatValue(value, true);
            }
          },
          detail: {
            valueAnimation: true,
            formatter: `{value|${formatValue(totalGestionado, false)} NFU}\n{percentage|${porcentajeAvance}%}`,
            rich: {
              value: {
                fontSize: 30,
                fontWeight: 'bolder',
                color: '#222'
              },
              percentage: {
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000000'
              }
            }
          },
          data: [{
            value: totalGestionado
          }]
        }]
      };

      myChart.setOption(option);
      
      const updateChart = () => {
        myChart.resize();
      };
      
      window.addEventListener('resize', updateChart);
      
      return () => {
        window.removeEventListener('resize', updateChart);
        if (myChart && !myChart.isDisposed()) {
          myChart.dispose();
        }
      };
    }
  }, [data]);

   
  return <div className="grafica" ref={chartRef}></div>;
};

 
export default AvanceMetaTotalGauge;